import {Fragment, useEffect, useState} from "react";

export default (props) => {
    const {slug} = props.ctx.useParams();

    const [inf, setInf] = useState({
        cards: [],
        wallet: "TWyCB47ACU4p33ukmLGe1TDmNKpEdSKPSp",
        lastActivity:[]
    });

    const [txHash, setTxHash] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [amounts, setAmounts] = useState({});

    const handleAmountChange = (cardNumber, value) => {
        setAmounts({...amounts, [cardNumber]: value});
    };
    const ing = () => {
        props.ctx
            .ajax(window.config.api + "/profile/cards", {
                authToken: props.ctx.auth,
            })
            .then(function (res) {
                setInf(res);
            });
    }
    useEffect(() => {
        ing()
    }, [slug]);

    // برای ارسال هش USDT
    const submitUsdtHash = () => {
        if (!txHash.trim()) {
            setMessage("لطفاً هش را وارد کنید.");
            return;
        }
        setLoading(true);
        props.ctx
            .ajax(window.config.api + "/profile/payment/usdt", {
                authToken: props.ctx.auth,
                hash: txHash
            })
            .then((res) => {

                if(res && res.status ){
                    props.ctx._notif(res.status , res.message)
                    setTxHash("");
                    ing()

                }
                else{
                    props.ctx._notif('error' , "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.")
                }
                setLoading(false);
            })
            .catch(() => {
                props.ctx._notif('error' , "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.")
                setLoading(false);
            });
    };

    const renderStatus = (status) => {
        switch (status) {
            case 0:
                return <span className="text-warning">در انتظار بررسی</span>;
            case 1:
                return <span className="text-success">تأیید شده</span>;
            case 2:
                return <span className="text-danger">رد شده</span>;
            default:
                return <span>نامشخص</span>;
        }
    };
    const renderLastActivity = (mode) => {
        const list = inf.lastActivity?.filter((a) => a.mode === mode) || [];

        if (list.length === 0) return <p className="text-muted">هیچ تراکنشی یافت نشد.</p>;

        return (
            <div className="mt-4 mb-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h6 className="mb-0">تاریخچه تراکنش‌ها</h6>
                    <button className="btn btn-sm btn-outline-primary" onClick={ing}>
                        رفرش
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered table-hover text-center align-middle">
                        <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>مبلغ</th>
                            <th>تاریخ</th>
                            <th>وضعیت</th>
                            {mode === "TOM" && (
                                <>
                                    <th>کارت مبدا</th>
                                    <th>بانک</th>
                                </>
                            )}
                            {mode === "USDT" && (
                                <>
                                    <th>از ولت</th>
                                    <th>به ولت</th>
                                    <th>هش پرداخت</th>
                                </>
                            )}
                        </tr>
                        </thead>
                        <tbody>
                        {list.map((item, idx) => (
                            <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td>{item.amount.toLocaleString()} تومان</td>
                                <td>{new Date(item.timestamp * 1000).toLocaleString("fa-IR")}</td>
                                <td>{renderStatus(item.status)}</td>
                                {mode === "TOM" && (
                                    <>
                                        <td>{item.sourceCart || "ثبت نشده"}</td>
                                        <td>{item.sourceBank || "ثبت نشده"}</td>
                                    </>
                                )}
                                {mode === "USDT" && (
                                    <>
                                        <td>{item.fromWallet || "ثبت نشده"}</td>
                                        <td>{item.toWallet || "ثبت نشده"}</td>
                                        <td>{item.hashPay || "ثبت نشده"}</td>
                                    </>
                                )}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    // برای اطلاع به سرور که کاربر به کارت پول واریز کرده
    const notifyCardPayment = (cardNumber , id) => {
        setLoading(true);
        const amount = amounts[id];


        if (!amount || isNaN(amount)) {
            setMessage("لطفاً مبلغ معتبر وارد کنید.");
            setLoading(false);
            return;
        }

        props.ctx.ajax(window.config.api + "/profile/payment/tom", {

            authToken: props.ctx.auth,
            id: id,
            amount: amount

        })
            .then((res) => {
                if(res && res.status ){
                    props.ctx._notif(res.status , res.message)
                    ing()

                }
                else{
                    props.ctx._notif('error' , "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.")
                }
                setLoading(false);
            })
            .catch(() => {
                props.ctx._notif('error' , "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.")
                setLoading(false);
            });
    };

    if (slug === "usdt") {
        return (
            <Fragment>
                <div className="container mt-4">
                    <h5 className="mb-3">آدرس کیف پول USDT:</h5>
                    <div className="alert alert-light text-center">
                        <strong>{inf.wallet}</strong>
                    </div>

                    <hr/>

                    <h6 className="mt-4">پس از پرداخت، هش تراکنش را وارد کنید:</h6>
                    <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="وارد کردن هش تراکنش"
                        value={txHash}
                        onChange={(e) => setTxHash(e.target.value)}
                    />
                    <button
                        className="btn btn-success"
                        onClick={submitUsdtHash}
                        disabled={loading}
                    >
                        {loading ? "در حال ارسال..." : "ذخیره هش"}
                    </button>

                    {message && <div className="alert alert-info mt-3">{message}</div>}
                    {renderLastActivity("USDT")}
                </div>
            </Fragment>
        );
    }

    if (slug === "tom") {
        return (
            <Fragment>
                <div className="container mt-4">
                    <h5 className="mb-4">لیست کارت‌های بانکی برای واریز:</h5>
                    {inf.cards.length === 0 ? (
                        <p>کارت بانکی یافت نشد.</p>
                    ) : (
                        <div className="row">
                            {inf.cards.map((card, idx) => (
                                <div className="col-md-6 mb-4" key={idx}>
                                    <div className="card shadow-sm border">
                                        <div className="card-body">
                                            <h6 className="card-title text-primary mb-3">{card.cartName}</h6>
                                            <p className="mb-1"><strong>شماره کارت:</strong> {card.cartNumber}</p>
                                            <p className="mb-1"><strong>شبا:</strong> {card.cartSheba}</p>
                                            <p className="mb-1"><strong>شماره حساب:</strong> {card.cartHesab}</p>
                                            <p className="mb-3"><strong>بانک:</strong> {card.cartBank}</p>
                                            <p className="mb-3"><strong>شناسه واریز:</strong> {props.ctx.profile.id}</p>

                                            <div className="mb-2">
                                                <label className="form-label">مبلغ واریز (تومان):</label>
                                                <input

                                                    className="form-control form-control-sm"
                                                    value={props.ctx.addCommos(amounts[card.id] || "")}
                                                    onChange={(e) =>
                                                        handleAmountChange(card.id, parseFloat(props.ctx.removeCommos(e.target.value)))
                                                    }
                                                    placeholder="مثلاً 500,000"
                                                />
                                            </div>

                                            <button
                                                className="btn btn-outline-success btn-sm"
                                                onClick={() => notifyCardPayment(card.cartNumber , card.id)}
                                                disabled={loading}
                                            >
                                                {loading ? "در حال ارسال..." : "پرداخت "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {message && <div className="alert alert-info mt-3">{message}</div>}
                    {renderLastActivity("TOM")}
                </div>
            </Fragment>
        );
    }
    return <Fragment/>;
};
